import React from 'react';

interface TableRowProps {
  header: string;
  headerClass?: string;
  data: string | JSX.Element;
  dataClass?: string;
  href?: string;
  userIcon?: boolean;
}

const UserInfoRow = React.memo(({ header, headerClass = '', data, dataClass = '', href = '', userIcon = false }: TableRowProps): JSX.Element => {
  const headerClassName: string = headerClass ?? '';
  const dataClassName: string = dataClass ?? '';
  const hasAnchor: boolean = href.length > 0;

  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <tr>
        <th scope="col" className={'user-icon border-0'}>
          {userIcon && (
            <i className="material-icons" style={{ fontSize: '1.25rem' }}>
              account_circle
            </i>
          )}
        </th>
        <th className={headerClassName}>{header}</th>
        <td className={dataClassName}>{hasAnchor ? <a href={href}>{data}</a> : <>{data}</>}</td>
      </tr>
    </>
  );
});

UserInfoRow.displayName = 'UserInfoRow';
export default UserInfoRow;
